<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'profile-session.title'"></app-header-bar>
  </div>
  <div class="content mt-2 mb-3 pt-3">
    <app-loading-indicator [loading]="isLoading"></app-loading-indicator>
    <app-error [error]="error"></app-error>
    @if (!isLoading) {
      <div class="row">
        @if (!isImpersonating) {
          <div class="d-flex justify-content-end">
            <button class="btn btn-danger btn-sm mb-3" (click)="terminateAllSessions()">
              {{ 'profile-session.revoke-all' | translate }}
            </button>
          </div>
        }
        @for (device of devices; track device) {
          <div>
            @for (session of deviceSessions(device); track session.id) {
              <div class="card mb-3">
                <div class="card-body">
                  <div class="d-flex justify-content-between">
                    <h6 class="card-title fw-bold">
                      {{ device.os }} {{ device.osVersion }} - {{ session.browser }}
                      @if (session.current) {
                        <span class="badge rounded-pill badge-outline bg-secondary ms-2">
                          {{ 'profile-session.current-session' | translate }}
                        </span>
                      }
                    </h6>
                    @if (!session.current && !isImpersonating) {
                      <button class="btn btn-sm btn-outline-secondary mb-3" style="margin-top: -0.5rem;"
                        (click)="terminateSession(session)">
                        {{ 'profile-session.revoke' | translate }}
                      </button>
                    }
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <h6 class="fw-bold">{{ 'profile-session.ip' | translate }}</h6>
                      <p class="card-text">{{ session.ipAddress }}</p>
                      <h6 class="fw-bold">{{ 'profile-session.last-activity' | translate }}</h6>
                      <p class="card-text" [innerHTML]="session.lastAccess | timeAgo"></p>
                    </div>
                    <div class="col-md-6">
                      <h6 class="fw-bold">{{ 'profile-session.started' | translate }}</h6>
                      <p class="card-text">{{ session.started | dateTime }}</p>
                      <h6 class="fw-bold">{{ 'profile-session.expires' | translate }}</h6>
                      <p class="card-text">{{ session.expires | dateTime }}</p>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
